export default "__VITE_ASSET__wLCeQK7Z__"